import {defineMessages, FormattedMessage} from '@pinecast/i18n';
import styled from '@pinecast/styles';

const Wrapper = styled('div', {
  padding: '40px 0',
  textAlign: 'center',
});
const TextWrapper = styled('div');

const messages = defineMessages({
  copy: {
    id: 'db-spa.TipJarPendingVerification.copy',
    description: 'Copy when we have send an email to verify the user',
    defaultMessage: 'An email is on its way. Check your inbox to continue.',
  },
});

const TipJarPendingVerification = () => (
  <Wrapper>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="64"
      width="64"
      style={{display: 'block', margin: '0 auto 20px'}}
    >
      <g
        stroke="#44484d"
        fill="none"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path
          d="M56.61 44.74A4 4 0 0 1 52.68 48H6.82a4 4 0 0 1-3.93-4.74l4.5-24A4 4 0 0 1 11.32 16h45.87a4 4 0 0 1 3.93 4.74l-4.5 24z"
          strokeWidth="3"
        />
        <path d="M61.11 20.74L32 32 7.39 19.26" strokeWidth="3" />
      </g>
    </svg>
    <TextWrapper>
      <FormattedMessage {...messages.copy} />
    </TextWrapper>
  </Wrapper>
);

export default TipJarPendingVerification;
